// assets/js/components/revenue-calculator/steps/step-6a.js
var ui = require("../ui");

var ALL_KEYS = [
    "usesOnlineBookingWebsite", "usesInstagramBooking", "usesReserveWithGoogle",
    "usesWaitlist", "usesReminders", "usesDeposits", "usesCancelPolicy",
    "usesForms", "usesMessaging", "usesReviewFlow"
];

function toolRow(id, label, d) {
    return ui.checkboxRow({ id: "rc-tool-" + id, checked: !!d[id], label: label });
}

function render(state) {
    var d = state.d;
    var noSys = d.hasBookingSystem === "No" || d.bookingSystem === "Google Calendar / manual";
    var html = ui.stepLabel(_t("Advanced step 1 of 3")) + ui.h2(_t("What tools are you currently using (even manually)?")) +
        ui.sub(_t("Select all you already use, even if done manually. This helps us estimate what could still be improved."));

    html += ui.checkboxRow({ id: "rc-tool-none", checked: !!d.noToolsYet, label: _t("I'm not using any tools yet") });
    html += '<div class="rc-calc__divider"></div>';

    if (!noSys) {
        html += ui.sectionLabel(_t("Booking channels"));
        html += toolRow("usesOnlineBookingWebsite", _t("Online booking on your website"), d);
        html += toolRow("usesInstagramBooking", _t("Instagram / Facebook booking links"), d);
        html += toolRow("usesReserveWithGoogle", _t("Reserve with Google"), d);
        html += toolRow("usesWaitlist", _t("Waitlist for cancelled or empty slots"), d);
    }

    html += ui.sectionLabel(_t("Revenue protection"));
    html += toolRow("usesReminders", _t("Automated reminders"), d);
    html += toolRow("usesDeposits", _t("Booking deposits"), d);
    html += toolRow("usesCancelPolicy", _t("Cancellation policy enforcement"), d);

    html += ui.sectionLabel(_t("Client experience"));
    html += toolRow("usesForms", _t("Digital intake or consultation forms"), d);
    html += toolRow("usesMessaging", _t("Two-way client communication"), d);
    html += toolRow("usesReviewFlow", _t("Review request flows"), d);

    html += ui.primaryButton({ id: "rc-continue-btn", label: _t("Continue") });
    return ui.card(html);
}

function bind(container, state, actions) {
    var d = state.d;
    container.querySelector("#rc-tool-none").addEventListener("change", function (e) {
        actions.setField("noToolsYet", e.target.checked);
        if (e.target.checked) ALL_KEYS.forEach(function (k) { actions.setField(k, false); });
        actions.rerender();
    });
    ALL_KEYS.forEach(function (k) {
        var el = container.querySelector("#rc-tool-" + k);
        if (!el) return;
        el.addEventListener("change", function (e) {
            actions.setField(k, e.target.checked);
            if (e.target.checked) actions.setField("noToolsYet", false);
            actions.rerender();
        });
    });
    container.querySelector("#rc-continue-btn").addEventListener("click", function () {
        state.adv = 1;
        actions.rerender();
    });
}

module.exports = { render: render, bind: bind };
